import React, { useEffect, useState } from "react";
import "./css/lastnews.css"; 

function LastNews() {
  const [posts, setPosts] = useState([]);
  
  useEffect(() => {
    // Fetch the last three posts from the API
    const fetchPosts = async () => {
      try {
        const response = await fetch('https://ghada-m2cb.onrender.com/api/posts'); 
        if (!response.ok) {
          throw new Error("Network response was not ok"); 
        }
        const data = await response.json();
        
        // Get the last three posts
        const lastThreePosts = data.slice(-3).reverse(); 
        setPosts(lastThreePosts);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="last-news-container" data-aos="fade-up">
      <h2>آخر الأخبار</h2>
      <div className="last-news-grid">
        {posts.length > 0 ? (
          posts.map((post) => (
            <div className="news-card" key={post._id}> {/* Use post._id as key */}
              {post.image && <img src={post.image} alt={post.title} className="news-image" />}
              <h3>{post.title}</h3>
              <p>{post.content.slice(0, 100)}...</p> 
              <span>{post.date}</span>
              <a href={`/post/${post._id}`} className="read-more-link">اقرأ المزيد</a> {/* Use post._id for dynamic routing */}
            </div>
          ))
        ) : (
          <p>لا توجد مدونات بعد</p>
        )}
      </div>
      <a href="/blog" className="view-all-btn">عرض جميع المقالات</a>
    </div>
  );
}

export default LastNews;
